<template>
  <page-header title="Перевозка кабеля"/>
  <div id="about" class="public-container public-container-mobile shipping-types">
    <div class="shipping-types-banner-wrapper shipping-types-block">
      <div class="shipping-types-banner mb-30">
        <public-card-info img-url="/images/pages/shipping-type/cable.png">
          <div class="shipping-types-card-text">
            {{ cardText }}
          </div>
        </public-card-info>
      </div>

      <div class="whitespace-break-spaces" v-html="content.blocks?.about.description"/>
    </div>

    <div class="shipping-types-block">
      <h2 class="vz-text-align-left">
        {{ content.blocks?.about.title }}
      </h2>

      <div class="whitespace-break-spaces mb-20" v-html="content.blocks?.about.text"/>
      <ul class="public-list public-list-square">
        <li v-for="text in content.blocks?.about.list.split(';')">
          <span>{{ text }}</span>
        </li>
      </ul>
    </div>

    <shipping-types-buttons />

    <div id="order" class="shipping-types-block">
      <h2 class="vz-text-align-left">
        {{ content.blocks?.order.title }}
      </h2>

      <div class="whitespace-break-spaces" v-html="orderDescription"/>
    </div>

    <div id="prr" class="shipping-types-block mb-90">
      <h2 class="vz-text-align-left">
        {{ content.blocks?.prr.title }}
      </h2>

      <p>
        {{ content.blocks?.prr.description }}
      </p>
    </div>

    <shipping-types-chain current="cable" />
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import {appleApp, googleApp} from '~/api/constant-urls'
import {storeToRefs} from 'pinia';
import {useCityStore} from '~/stores/city';
import {getPageContent, replaceContentText} from '~/api/content';

const {currentCity} = storeToRefs(useCityStore())

const content = await getPageContent('/shippingtypes/cable')

const cardText = computed(() => {
  return replaceContentText(content.blocks?.about.cardText, {city: currentCity.value})
})

const orderDescription = computed(() => {
  return replaceContentText(content.blocks?.order.description, {appleApp, googleApp})
})
</script>
